import classNames from "classnames";
import classes from "../LmsModalStyles.module.less";
import Modal from "~/common/components/Modal";
import { Button } from "~/common/components/Button/Button";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";
import { Stacker } from "~/common/components/Stacker/Stacker";

interface Props {
  onClose: () => void;
  onIgnore: () => void;
  onSetup: () => void;
}

export const LmsInactiveModal = (props: Props) => {
  const isMinTablet = useIsMinTabletSize();
  const { t } = useTranslation();
  return (
    <Modal
      onClose={props.onClose}
      footerChildren={
        <Stacker gap={8} direction="row">
          <Button variant={"text"} onClick={props.onIgnore}>
            {t("feature.lms.modal.button.not_now")}
          </Button>
          <Button onClick={props.onSetup}>{t("feature.lms.modal.button.set_up")}</Button>
        </Stacker>
      }
    >
      <p className={classNames(classes.root)}>
        <Trans i18nKey="feature.lms.modal.inactive.text" />
      </p>
    </Modal>
  );
};
